// extracted by mini-css-extract-plugin
export default {"modify_order_header":"bz","center":"cz","empty":"ez","pending":"fz","referralTitle":"gz","wrapper":"hz","title":"iz","tabs":"jz","tab":"kz","active":"lz","btn":"mz","rewards_table":"nz"};
    if(module.hot) {
      // 1713211519993
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  